import { render, staticRenderFns } from "./RunList.vue?vue&type=template&id=40136dda&"
import script from "./RunList.vue?vue&type=script&lang=js&"
export * from "./RunList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports